import moment from 'moment'
import React from 'react'
import MuiSlider from '@material-ui/core/Slider'

import { useStyles } from './slider.style'

/**
 * Wrapper around Material UI Slider that adds support for dates and applies our own style overrides
 */
export const Slider = function ({
  value,
  min,
  max,
  marks,
  step = null,
  dateMode = false,
  dateValueFormat = 'MMM YYYY',
  track = false,
  valueLabelDisplay = 'auto',
  onChange = () => {},
  onChangeCommitted = () => {},
  ...props
}) {
  const classes = useStyles()

  function convertDateToNumber (value) {
    return moment.utc(value).valueOf()
  }

  function convertNumberToDate (value) {
    return moment.utc(value).toDate()
  }

  function convertMarks (marks) {
    if (!dateMode) {
      return marks
    }

    if (!marks || !Array.isArray(marks)) {
      return false
    }

    return marks.map((m) => {
      if (typeof m === 'object') {
        const value = convertDateToNumber(m.value)
        return { value, label: m.label }
      }
    })
  }

  function formatLabels (value) {
    return dateMode ? moment.utc(value).format(dateValueFormat) : value
  }

  function handleChange (event, value) {
    onChange(event, dateMode ? convertNumberToDate(value) : value)
  }

  return <MuiSlider classes={classes}
    value={dateMode ? convertDateToNumber(value) : Number(value)}
    min={dateMode ? convertDateToNumber(min) : min}
    max={dateMode ? convertDateToNumber(max) : max}
    marks={convertMarks(marks)}
    step={step}
    track={track}
    valueLabelFormat={formatLabels}
    valueLabelDisplay={valueLabelDisplay}
    onChange={handleChange}
    onChangeCommitted={onChangeCommitted}
    {...props}
  />
}
